/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * A required media track whose loss/mute violates exam integrity.
 */
export type OralExamMediaSource = (typeof OralExamMediaSource)[keyof typeof OralExamMediaSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamMediaSource = {
  camera: 'camera',
  microphone: 'microphone',
  screen: 'screen',
  connection: 'connection',
  recording: 'recording',
} as const;
